import { useState } from 'react';

export default function NewsletterCTA() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formEl = e.currentTarget;
    const formData = new FormData(formEl);
    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setEmail('');
      return;
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d9peq8hn2trhb35gve50', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const text = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试';
        setErrorMsg(msg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请检查连接后重试');
      setStatus('error');
    }
  };

  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20pastel%20gradient%20wallpaper%20with%20floating%20cute%20comic%20speech%20bubbles%20and%20tiny%20hearts%2C%20warm%20peach%20and%20pink%20tones%2C%20dreamy%20and%20whimsical%20background%2C%20minimal%20and%20clean%20design&width=1600&height=600&seq=cta-bg-taotao&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-background-950/55 backdrop-blur-[2px]"></div>
      </div>

      <div className="relative z-10 max-w-[700px] mx-auto px-6 text-center">
        <h2 className="text-xl md:text-2xl font-heading text-background-50 mb-3">订阅更新通知</h2>
        <p className="text-sm text-background-200 mb-6">
          第一时间获取最新韩国漫画更新通知，不错过任何精彩内容
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
        >
          <div className="hidden" aria-hidden="true">
            <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" readOnly />
          </div>
          <input
            type="email"
            name="email"
            required
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setStatus('idle');
            }}
            placeholder="输入您的邮箱地址"
            className="flex-1 w-full px-5 py-3 rounded-full text-sm bg-background-50/90 border border-background-50/20 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300"
          />
          <button
            type="submit"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            立即订阅
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-sm text-accent-300">订阅成功！感谢您的关注~</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-red-300">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}